var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66663 4.6665V13.9998",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.83836 2.60577C5.63487 1.48331 3.90079 2.14096 3.03613 2.8128C2.88028 2.9339 2.80235 2.99445 2.73449 3.13311C2.66663 3.27178 2.66663 3.40092 2.66663 3.6592V9.82127C3.31309 9.08947 5.25249 7.9552 7.83836 9.2724C10.1493 10.4496 12.116 9.9616 13.0464 9.453C13.1755 9.38247 13.24 9.34713 13.2867 9.26853C13.3333 9.18993 13.3333 9.1046 13.3333 8.93393V3.91593C13.3333 3.36359 13.3333 3.08742 13.2018 2.98737C13.0702 2.88733 12.7624 2.97267 12.1468 3.14336C11.0933 3.43546 9.56149 3.48355 7.83836 2.60577Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.04eba5f0089d6a07c0ce015e3a1a9744.svg";
export { ForwardRef as ReactComponent };